import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../../../components/Navbar";
import Subnav from "../SubNav";
import Footer from "../../../components/Footer";
import CollectPayment, { createPayment } from "./CollectPaymentComponent";
import { fetchPayments, fetchSale } from "../SaleDetails/SaleDetails";

export default function CollectPaymentPage() {
  const { id } = useParams(); // get /sales/:id
  const navigate = useNavigate();

  return (
    <div>
      <Navbar />
      <Subnav />
      <div className="min-h-screen bg-gray-50">
        <CollectPayment
          saleId={id}
          fetchSaleSummary={fetchSale}
          fetchPayments={fetchPayments}
          createPayment={createPayment}
          onBack={() => navigate(-1)} // go back
        />
      </div>
      <Footer />
    </div>
  );
}
